export default function ChartGenerationFactory($log, chartServices) {
  'use strict';
  'ngInject';

  return {
    /**
     * Utilizes a set of data to generate the JSON structure needed to render a micro-chart. At the moment the output
     * is a Highcharts config data structure but that may change in the future when we can (hopefully) move to D3.js.
     *
     * @param data This should be the data returned by a call to
     *   /aptitude/api/rfps/<RFP ID>/sellers/<Seller ID>/pricingcomparison?duration=<Duration in months>&partnerId=<Partner ID>&priceType=<Fixed or Variable>
     *   Please consult the API documentation for details.
     * @param targetMarketShare
     * @param currentMarketShare
     * @returns {*} A Highcharts configuration object.
     */
    generateMicroChart: function (data, targetMarketShare, marketShare) {
      //      $log.log('generateMicroChart', data, targetMarketShare, marketShare);

      // getSellerToCompareConfig expects to receive the source data for building a micro-chart wrapped in an outer
      // object.
      if (data) {
        var terms = {
          sellers: [data]
        };

        var allocations = {
          targetMarketShare: targetMarketShare,
          marketShare: marketShare
        };

        return chartServices.getSellerToCompareConfig({}, terms, allocations);
      } else {
        return null;
      }
    },

    _pixelShimCalculator: function () {
      // Poor form to query the DOM from here, but the alternatives are all quite cumbersome for this simple task.
      // Each rendering engine produces slightly different results with the same data passed to the Highcharts.renderer
      // method.
      // Seems to be no alternative but to browser-sniff.
      var $html = $('html');

      if ($html.hasClass('gecko')) {
        if ($html.hasClass('win')) {
          return { pixelShimWidth: 3, pixelShimHeight: 0 };
        } else {
          return { pixelShimWidth: 2, pixelShimHeight: 0 };
        }

        // This code will never run.
        // I think commenting out the else above is correct, but I don't want to change this if no one's complaining
        if ($html.hasClass('webkit')) {
          return { pixelShimWidth: 0, pixelShimHeight: 0 };
        }

        if ($html.hasClass('trident')) {
          return { pixelShimWidth: 1, pixelShimHeight: 0 };
        }
      }

      return { pixelShimWidth: 0, pixelShimHeight: 0 };
    },

    generateMacroChart: function (
      data,
      targetMarketShare,
      marketShare,
      allBuyers,
      likeMe,
      benchmarks
    ) {
      if (data) {
        // getSellerToCompareConfig expects to receive the source data for building a micro-chart wrapped in an outer
        // object.
        var terms = {
          sellers: [data]
        };

        var allocations = {
          targetMarketShare: targetMarketShare,
          marketShare: marketShare
        };

        // The only reason for copying the benchmarks data is to fix the similar -> likeMe naming conventions. Sigh.
        var componentData = {
          marketShare: marketShare,
          coverage: {
            something: true
          },
          benchmarks: {
            all: {
              best: benchmarks.all.best,
              average: benchmarks.all.average
            },
            likeMe: {
              best: benchmarks.similar.best,
              average: benchmarks.similar.average
            }
          }
        };
        var chartData = chartServices.getSellerToCompareConfig(
          {},
          terms,
          allocations
        );
        var bigChartData = chartServices.createGraphData(
          componentData,
          chartData,
          allBuyers,
          likeMe,
          this._pixelShimCalculator(),
          targetMarketShare
        );
        return bigChartData;
      } else {
        return null;
      }
    }
  };
}
